<template>
  <div class="live-checklist-wrapper">
    <import ref="import" :extraParams='{ folder_id: folder.id }' data-backdrop="false" v-if="canAdd" />

    <div v-if='!folder.track_progress' class="note">
      {{ $t('checklist.note_checklist') }}
    </div>

    <div class="ui-line-wrapper" :class="{'full': $props.resource==='outlook_addin' }">
      <status :items-count="totalChecklistItemsLength" :completed-items-count="completedItemsLength" />
    </div>

    <div class="ui-line-wrapper" :class="{'full': $props.resource==='outlook_addin' }">
      <div class="search-container-wrapper">
        <i class="fas fa-search"></i>
        <i class="fas fa-times" v-if="q.length > 0" @click="q = ''"></i>
        <input type="text" name="search" v-model="q" class="form-control search-field" autocomplete="off" :placeholder="$t('checklist.search')" />
      </div>
      <a v-if="canAdd" class="btn btn-outline-primary btn-sm btn-import float-right" href="#" @click.prevent="$refs.import.open">
        {{ $t('checklist.import_checklist') }}
      </a>
    </div>

    <div v-if="canAdd" class="ui-line-wrapper" :class="{'full': $props.resource==='outlook_addin' }">
      <h4>{{ $t('record_show.add_items') }}</h4>
      <add-items :folder='folder' :record='record' @success='loadChecklist()' :resource="$props.resource" />
    </div>

    <div v-if="pendingItems.length === 0 && completedItems.length === 0" class="empty-list-wrapper" :class="{'full': $props.resource==='outlook_addin' }">
      <img src="../../assets/empty_states/checklist.png"/>
      <p>
        <span v-show="canAdd">
          {{ $t('checklist.empty') }}
        </span>
        <span v-show="!canAdd">
          {{ $t('checklist.shared_empty') }}
        </span>
        <br/>
        {{ $t('checklist.adding_items') }}
      </p>
    </div>

    <table v-else class="table checklist-table">
      <div class="complete-items-handler tbl-header" v-if="filteredCompleted.length > 0" @click="completedHidden = !(completedHidden)" :class="{'closed': completedHidden}">
        <label class="checkbox-container">
          <input type="checkbox" name="item[checked]" checked>
          <span class="checkmark" data-toggle="tooltip" title="" data-original-title="Deselect all items" @click='deselectAll'></span>
        </label>
        <span>
          {{ $t('checklist.completed_items') }} ({{filteredCompleted.length}})
        </span>
        <i class="mdi mdi-arrow-down"></i>
      </div>

      <div class="complete-items-wrapper" :class="{ closed: completedHidden }">
        <transition-group name="list" tag="tbody">
          <tr v-if="q.length > 0 && filteredCompleted.length === 0 && completedItems.length > 0" :key="0" class="list-item">
            <td colspan="3" class="empty-row">
              {{ $t('checklist.no_results') }}
            </td>
          </tr>
          <tr v-for="item in filteredCompleted" :key="item.id" class="list-item">
            <td class="checklist-check-column">
              <label class="checkbox-container">
                <input type="checkbox" name="item[checked]" @change="updateItem(item)" :checked="item.checked">
                <span class="checkmark"></span>
              </label>
            </td>
            <td class="checklist-content-column">
              <div class="document-type-bubble">
                <span v-if="noNavigation">
                  {{ item.document.name }}
                </span>
                <router-link v-else :to="{ name: 'document_type', params: { id: item.document.id} }" class='file-link'>
                  {{ item.document.name }}
                </router-link>
              </div>

              <div class="product-bubble">
                <span v-if="noNavigation">
                  {{ item.product.name }}
                </span>
                <router-link v-else :to="{ name: 'product', params: { id: item.product.id} }" class='file-link'>
                  {{ item.product.name }}
                </router-link>
              </div>

              <div class="clearfix"></div>

              <div class="file-bubble">
                <b>{{ $t('checklist.uploaded_file') }}</b>
                <span v-if="noNavigation">
                  {{ record.filename }}
                </span>
                <router-link v-else :to="{ name: 'record', params: { id: record.id } }" class='file-link'>
                  {{ record.filename }}
                </router-link>

                <br/>

                <div class="exp-status">
                  <span v-if="record.status === 'current'">
                    {{ $t('records_list.table.up_to_date') }}
                  </span>
                  <span v-else-if="record.status === 'soon'" class="soon">
                    {{ $t('records_list.table.expires_soon') }}
                  </span>
                  <span v-else-if="record.status === 'expired'" class="expired">
                    {{ $t('records_list.table.expired') }}
                  </span>
                  <span v-else class="no-expiration">
                    {{ $t('records_list.table.no_expiration') }}
                  </span>
                </div>
              </div>
            </td>
            <td class="actions checklist-action-column">
              <ul>
                <li title="Delete Checklist Item">
                  <a @click="destroyItem(item)" class="far fa-trash-alt"></a>
                </li>
              </ul>
            </td>
          </tr>
        </transition-group>
      </div>
      <div class="complete-items-handler tbl-header" v-if="pendingItems.length > 0" @click="pendingHidden = !(pendingHidden)" :class="{'closed': pendingHidden}">
        <label class="checkbox-container">
          <input type="checkbox" name="item[checked]">
          <span class="checkmark" data-toggle="tooltip" title="" :data-original-title="$t('checklist.select_all')" @click='selectAll'></span>
        </label>
        <span>
          {{ $t('checklist.pending_items') }} ({{filteredPending.length}})
        </span>
        <i class="mdi mdi-arrow-down"></i>
      </div>
      <div class="complete-items-wrapper" :class="{ closed: pendingHidden }">
        <transition-group name="list" tag="tbody">
          <tr v-if="q.length > 0 && filteredPending.length === 0 && pendingItems.length > 0" v-bind:key="0" class="list-item">
            <td colspan="3" class="empty-row">
              {{ $t('checklist.no_results') }}
            </td>
          </tr>
          <tr v-for="item in filteredPending" :key="item.id" class="list-item">
            <td class="checklist-check-column">
              <label class="checkbox-container">
                <input type="checkbox" name="item[checked]" @change="updateItem(item)" :checked="item.checked">
                <span class="checkmark"></span>
              </label>
            </td>
            <td class="checklist-content-column">
              <div class="document-type-bubble">
                <span v-if="noNavigation">
                  {{ item.document.name }}
                </span>
                <router-link v-else :to="{ name: 'document_type', params: { id: item.document.id} }" class='file-link'>
                  {{ item.document.name }}
                </router-link>
               </div>
              <div class="product-bubble">
                <span v-if="noNavigation">
                  {{ item.product.name }}
                </span>
                <router-link v-else :to="{ name: 'product', params: { id: item.product.id} }" class='file-link'>
                  {{ item.product.name }}
                </router-link>
              </div>
            </td>
            <td class="actions checklist-action-column">
              <ul>
                <li data-toggle="tooltip" title="" data-original-title="Delete Checklist Item" @click="$event.stopPropagation()">
                  <a @click="destroyItem(item)" class="far fa-trash-alt"></a>
                </li>
              </ul>
            </td>
          </tr>
        </transition-group>
      </div>
    </table>
  </div>
</template>
<script>
  import _add_items from './_add_items'
  import _status from '../checklists/_status'
  import _import from '../checklists/_import'

  export default {
    components: {
      status: _status,
      import: _import,
      'add-items': _add_items,
    },
    props: {
      record: {
        type: Object,
        required: true,
      },
      folder: {
        type: Object,
        required: true,
      },
      resource: {
        type: String,
        default: () => { return null }
      },
      importEnabled: {
        type: Boolean,
        default: () => { return true }
      },
    },
    created() {
      this.loadChecklist()
      this.sendMetric('open_checklist_modal')
    },
    data() {
      return {
        q: '',
        pendingHidden: false,
        completedHidden: false,
      }
    },
    computed: {
      items() {
        return this.lists.checklists || []
      },
      completedItems() {
        return this.items.filter(i => i.checked && i.record_id == this.record.id)
      },
      pendingItems() {
        return this.items.filter(i => !i.checked)
      },
      lowerQ() {
        return this.q.toLowerCase()
      },
      filteredCompleted() {
        if (this.q.length < 1)
          return this.completedItems

        return this.completedItems.filter(i => {
          const pNameLower = i.product.name.toLowerCase()
          const dNameLower = i.document.name.toLowerCase()

          return pNameLower.indexOf(this.lowerQ) >= 0 || dNameLower.indexOf(this.lowerQ) >= 0
        })
      },
      filteredPending() {
        if (this.q.length < 1)
          return this.pendingItems

        return this.pendingItems.filter(i => {
          const pNameLower = i.product.name.toLowerCase()
          const dNameLower = i.document.name.toLowerCase()

          return pNameLower.indexOf(this.lowerQ) >= 0 || dNameLower.indexOf(this.lowerQ) >= 0
        })
      },
      checklistItemStats() {
        return this.stats.checklistItems || {}
      },
      totalChecklistItemsLength() {
        return this.checklistItemStats.total
      },
      completedItemsLength() {
        return this.checklistItemStats.checked
      },
      canAdd(){
        return (this.$props.resource === 'SharedRecord') ? false : true
      },
      noNavigation(){
        return(this.$props.resource === 'outlook_addin')
      }
    },
    methods: {
      selectAll() {
        const params = {
          checked: true,
          record_id: this.record.id,
          checklist_item_ids: this.filteredPending.map(c => c.id),
          resource: this.$props.resource
        }
        this.axios.post('/checklist_items/bulk_update', params).then(() => {
          this.loadChecklist()
          this.$emit('success')
          this.sendMetric('bulk_select_checklist')
        })
      },
      deselectAll() {
        const params = {
          checked: false,
          record_id: this.record.id,
          checklist_item_ids: this.filteredCompleted.map(c => c.id),
          resource: this.$props.resource
        }
        this.axios.post('/checklist_items/bulk_update', params).then(() => {
          this.loadChecklist()
          this.$emit('success')
          this.sendMetric('bulk_deselect_checklist')
        })
      },
      loadChecklist() {
        this.listStore.getChecklistItems({ 'filters[folder_id]': this.folder.id, resource: this.$props.resource })
        this.statStore.getChecklistItems({ 'filters[folder_id_eq]': this.folder.id, resource: this.$props.resource })
      },
      updateItem(item) {
        let params = {
          item: { checked: !item.checked, record_id: this.record.id }, resource: this.$props.resource
        }

        this.store.updateChecklistItem(item.id, params).then(() => {
          this.loadChecklist()
          this.$emit('success')
          this.sendMetric('update_checklist')
        })
      },
      destroyItem(item) {
          this.store.destroyChecklistItem(item.id, { resource: this.$props.resource }).then(() => {
          this.loadChecklist()
          this.$emit('success')
          this.sendMetric('remove_checklist')
        })
      },
      sendMetric(name){
        let resource = this.$props.resource
        this.store.sendMetrics({
          name: ((resource) ? name+'_from_'+resource : name),
          params: this.$route.params,
          path: this.$route.fullPath
        })
      }
    },
  }
</script>

<style lang="sass">
  @import "../../styles/checklists.sass"
  .note
    background-color: #EAF0FF
    padding: 5px
    border-radius: 5px
    font-size: 14px
    color: #000
    margin-bottom: 20px
  .search-container-wrapper
    width: 50%
  .ui-line-wrapper
    &.full
      .search-container-wrapper
        clear: both
        width: 100%
      .btn-import
        margin-top: 10px

  .checklist-items .ui-line-wrapper
    margin-top: 20px
    overflow: visible
    float: left
    width: 100%
    &:first-child
      margin-top: 10px
    h4
      font-size: 16px
      color: #000
      margin-top: 0
  .live-checklist-wrapper
    .empty-list-wrapper
      img
        width: 70px
        margin: 10px 0
    .ui-line-wrapper
      &.full
        .relatico-select-wrapper
          margin-bottom: 0px
        .btn
          padding: .25rem .5rem
          font-size: .875rem
          line-height: 1.5
          border-radius: .2rem
          font-weight: 400
          position: relative

        h4
          font-size: 16px
          margin-bottom: 20px
        .completeness
          .completeness-bar
            margin-top: 0px
          .completeness-stats
            width: 100%
          .progress
            width: 100%
    .empty-list-wrapper
      &.full
        p
          font-size: 14px
          width: 80%
          margin: 0 auto 10px

  .tag-dropdown
    .btn-outline-primary
      margin-left: 10px
</style>
